<div class="p-4">
    <h2 id="dialog-title" class="text-xl font-semibold mb-2">{{ dialogConfig.data.title | translate }}</h2>

    <p id="dialog-description" class="mb-6">{{ dialogConfig.data.description | translate }}</p>

    <div class="flex justify-end space-x-3">
        <sag-ui-button color="tertiary" (click)="onCancel()" (keydown.space)="onCancel()">
            {{
                dialogConfig.data.cancelLabel
                    ? dialogConfig.data.cancelLabel
                    : ('general.confirmation-dialog.cancel-button' | translate)
            }}
        </sag-ui-button>

        <sag-ui-button
            [color]="dialogConfig.data.isWarning ? 'danger' : 'primary'"
            (click)="onConfirm()"
            (keydown.space)="onConfirm()"
        >
            {{
                dialogConfig.data.confirmLabel
                    ? dialogConfig.data.confirmLabel
                    : ('general.confirmation-dialog.confirm-button' | translate)
            }}
        </sag-ui-button>
    </div>
</div>
